"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computePrices = exports.findChannelTierPrice = exports.calculateDiscountedPiecePrice = exports.findChannelPrice = void 0;
var money_1 = __importDefault(require("../utils/money"));
var sku_1 = require("../utils/sku");
function findChannelPrice(prices, distributionChannelKey) {
    if (distributionChannelKey === void 0) { distributionChannelKey = 'autoDelivery5Off'; }
    return prices.find(function (priceItem) { var _a, _b; return ((_b = (_a = priceItem.channel) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.key) === distributionChannelKey; });
}
exports.findChannelPrice = findChannelPrice;
function calculateDiscountedPiecePrice(params) {
    var _a;
    var prices = params.prices, wholesale = params.wholesale, piecePrice = params.piecePrice, quantity = params.quantity, interval = params.interval;
    if (wholesale || !interval) {
        return piecePrice;
    }
    var channelPrice = findChannelPrice(prices);
    var tieredChannelPrice = channelPrice
        ? findChannelTierPrice(channelPrice, quantity)
        : undefined;
    return ((_a = tieredChannelPrice !== null && tieredChannelPrice !== void 0 ? tieredChannelPrice : channelPrice === null || channelPrice === void 0 ? void 0 : channelPrice.value) !== null && _a !== void 0 ? _a : money_1.default.multiply(piecePrice, 0.95));
}
exports.calculateDiscountedPiecePrice = calculateDiscountedPiecePrice;
function findChannelTierPrice(channelPrice, quantity) {
    var _a, _b;
    return (_b = (_a = channelPrice === null || channelPrice === void 0 ? void 0 : channelPrice.tiers) === null || _a === void 0 ? void 0 : _a.filter(function (t) { return quantity >= t.minimumQuantity; }).pop()) === null || _b === void 0 ? void 0 : _b.value;
}
exports.findChannelTierPrice = findChannelTierPrice;
function computePrices(params) {
    var _a, _b;
    var variant = params.variant, quantity = params.quantity, interval = params.interval, committedPiecePrice = params.committedPiecePrice;
    var defaultPrice = (_b = (_a = variant.prices) === null || _a === void 0 ? void 0 : _a.find(function (p) { return p.value.currencyCode === 'USD' && !p.channel; })) === null || _b === void 0 ? void 0 : _b.value;
    var currentPiecePrice = money_1.default.from((0, sku_1.priceForQuantity)(__assign(__assign({}, variant), { prices: variant.prices, salePrice: money_1.default.dollars(defaultPrice) }), quantity));
    var piecePriceToUse = committedPiecePrice !== null && committedPiecePrice !== void 0 ? committedPiecePrice : currentPiecePrice;
    var discountedPiecePrice = calculateDiscountedPiecePrice({
        prices: variant.prices || [],
        wholesale: variant.wholesale,
        piecePrice: piecePriceToUse,
        quantity: quantity,
        interval: interval,
    });
    var extendedPrice = money_1.default.multiply(piecePriceToUse, quantity);
    var discountedExtendedPrice = money_1.default.multiply(discountedPiecePrice, quantity);
    return {
        currentPiecePrice: currentPiecePrice,
        piecePrice: piecePriceToUse,
        discountedPiecePrice: discountedPiecePrice,
        extendedPrice: extendedPrice,
        discountedExtendedPrice: discountedExtendedPrice,
    };
}
exports.computePrices = computePrices;
//# sourceMappingURL=prices.js.map